import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import CustomerBillingSummaryCSP from "../../../models/csp/CustomerBillingSummaryCSP";
import customerBillingSummaryService from "../../../services/csp/customerBillingSummaryService";
import { RootState } from "../../index";

const namespaced = true;

interface CustomerBillingSummaryState {
  customersBillingSummaries: CustomerBillingSummaryCSP[];
}

const state: CustomerBillingSummaryState = {
  customersBillingSummaries: []
};

const getters: GetterTree<CustomerBillingSummaryState, RootState> = {
  getCustomerBillingSummaryCSP:
    state =>
    (customerId: string): CustomerBillingSummaryCSP => {
      return state.customersBillingSummaries.find(
        summary => summary.getCustomerId === customerId
      );
    }
};

const mutations: MutationTree<CustomerBillingSummaryState> = {
  addCustomerBillingSummary(
    state,
    customerBillingSummary: CustomerBillingSummaryCSP
  ) {
    state.customersBillingSummaries.push(customerBillingSummary);
  }
};

const actions: ActionTree<CustomerBillingSummaryState, RootState> = {
  async loadCustomerBillingSummaryCSP({ commit }, id: string) {
    const exists = state.customersBillingSummaries.some(
      summary => summary.getCustomerId === id
    );
    if (!exists) {
      const billingSummary: CustomerBillingSummaryCSP =
        await customerBillingSummaryService.methods.getCustomerBillingSummaryCSP(
          id
        );
      commit("addCustomerBillingSummary", billingSummary);
    }
  }
};

export const customerBillingSummaryModuleCSP: Module<
  CustomerBillingSummaryState,
  RootState
> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
